import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {conditionSelector, forAllSidesSelector} from "../../../selectors";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import NoSsr from "@material-ui/core/NoSsr";
import isTransparent from "../../../services/lib/is-transparent";
import ColorPicker from "../../ColorPicker";
import Tooltip from "@material-ui/core/Tooltip";
import ColorWheelIcon from "../../ColorWheelIcon";
import trackEvent from "../../../../../utils/track-event";
import withMobileContext from "../../../decorators/withMobileContext";
import {setForAllSides} from "../../../AC/set-for-all-sides";

export class LineWithColorPicker extends Component {
  static propTypes = {
    variant: PropTypes.string,
    title: PropTypes.string,
    items: PropTypes.array,
    changeVariant: PropTypes.func,
    setForAllSides: PropTypes.func,
    condition: PropTypes.object,
    forAllSides: PropTypes.bool,
    isMobile: PropTypes.bool
  };
  handleCheckboxChange = (e) => {
    const {checked} = e.target;
    this.props.setForAllSides(checked);
    if (checked) {
      const {variant, changeVariant} = this.props;
      const currentValue = this.getCurrentValue();
      changeVariant(e, variant, currentValue, true);
    }
  };
  getCurrentValue() {
    const {
      condition: {
        design: {background}
      }
    } = this.props;

    if (isTransparent(background)) {
      return `transparent`;
    }
    return background;
  }
  render() {
    const {items, variant, changeVariant, isMobile, forAllSides} = this.props;
    const currentValue = this.getCurrentValue();
    return (
      <div className={`variant variant_${variant}`}>
        <div className="variant__content">
          {items.map((val) => (
            <div
              key={val}
              className={`variant-option variant-option_${variant} variant__item${
                currentValue === val ? ` variant-option_active` : ``
              }`}
              onClick={(e) => {
                changeVariant(e, variant, val, forAllSides);
              }}
            >
              <span
                className={`variant-option__fill${
                  val === `transparent`
                    ? ` variant-option__fill_transparent`
                    : ``
                }`}
                style={{
                  backgroundColor: val,
                  backgroundPosition: `center center`
                }}
              />
            </div>
          ))}
          <div className="variant-color-picker">
            <ColorPicker
              color={currentValue}
              onChange={(e, pickerType) => {
                changeVariant(e, variant, e.rgb);
                if (pickerType === `palette`) {
                  trackEvent({
                    category: `Editor`,
                    action: `Palette`,
                    label: `Background color`
                  });
                }
              }}
              position={isMobile ? `bottom-left` : `bottom-right`}
            >
              <Tooltip title="Показать все цвета">
                <div className="palette">
                  <ColorWheelIcon />
                </div>
              </Tooltip>
            </ColorPicker>
          </div>
          <div className="variant__checkbox">
            <NoSsr>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={forAllSides}
                    onChange={this.handleCheckboxChange}
                    value="checked"
                    color="primary"
                  />
                }
                label="Применять ко всем сторонам"
              />
            </NoSsr>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  condition: conditionSelector(state),
  forAllSides: forAllSidesSelector(state)
});

const mapDispatchToProps = {
  setForAllSides
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileContext(LineWithColorPicker));
